export const TOP_INVESTORS_LOADING = "TOP_INVESTORS__LOADING";
export const TOP_INVESTORS_ERROR = "TOP_INVESTORS__ERROR";
export const TOP_INVESTORS_SUCCESS = "TOPINVESTERS__SUCCESS";